import { withInstall } from '@antdv/utils';
import AFlex from './src/Flex';

export const Flex = withInstall(AFlex);

export default Flex;

export * from './src/props';
